import { AccountActionTypes } from './constants';

type AccountAction = { type: string; payload: {} | string };

// common success
export const accountApiResponseSuccess = (actionType: string, data: any): AccountAction => ({
    type: AccountActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const accountApiResponseError = (actionType: string, error: string): AccountAction => ({
    type: AccountActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const createAccount = (data: object): AccountAction => ({
    type: AccountActionTypes.CREATE_ACCOUNT,
    payload: { data },
});

export const getAccounts = (options: object): AccountAction => ({
    type: AccountActionTypes.GET_ACCOUNTS,
    payload: options,
});

export const getAccount = (id: string): AccountAction => ({
    type: AccountActionTypes.GET_ACCOUNT_BY_ID,
    payload: { id },
});

export const getAccountsByUser = (user: string): AccountAction => ({
    type: AccountActionTypes.GET_ACCOUNTS_BY_USER,
    payload: { user },
});

export const getAccountsByOrganization = (user: string): AccountAction => ({
    type: AccountActionTypes.GET_ACCOUNTS_BY_ORGANIZATION,
    payload: { user },
});

export const updateAccount = (id: string, data: object): AccountAction => ({
    type: AccountActionTypes.UPDATE_ACCOUNT,
    payload: { id, data },
});

export const deleteAccount = (id: string, data: object): AccountAction => ({
    type: AccountActionTypes.DELETE_ACCOUNT,
    payload: { id },
});

export const sendAccountEmail = (id: string, data: object): AccountAction => ({
    type: AccountActionTypes.SEND_ACCOUNT_EMAIL,
    payload: { id, data },
});

export const getAccessByAccount = (id: string): AccountAction => ({
    type: AccountActionTypes.GET_ACCOUNT_ACCESS,
    payload: { id },
});

export const revokeAccessByAccount = (id: string, data: object): AccountAction => ({
    type: AccountActionTypes.REVOKE_ACCOUNT_ACCESS,
    payload: { id, data },
});

export const resetAccounts = (): AccountAction => ({
    type: AccountActionTypes.RESET_ACCOUNTS,
    payload: {},
});
